import React, { useEffect, useRef } from 'react';
import useSelector from '@redux/typedHooks';
import * as S from './Searchbar.styles';

export interface SearchBarProps {
  onSearchInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: (event: React.FormEvent<HTMLFormElement>) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export const SearchBar = ({
  onSearch,
  onSearchInputChange,
  placeholder = 'Søk',
  autoFocus = false,
}: SearchBarProps) => {
  const searchInputText = useSelector((state) => state.internalSiteSearch.query);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);

  return (
    <S.SearchBarWrapper>
      <S.StyledForm role="search" aria-label="Søk på naf.no" onSubmit={onSearch}>
        <S.InputWrapper>
          <S.SearchIcon size={24} aria-hidden="true" focusable="false" />
          <S.StyledInput
            ref={inputRef}
            id="searchInput"
            name="searchQuery"
            onChange={onSearchInputChange}
            type="text"
            enterKeyHint="search"
            placeholder={placeholder}
            value={searchInputText}
            aria-label="Søk på naf.no"
          />
        </S.InputWrapper>
      </S.StyledForm>
    </S.SearchBarWrapper>
  );
};
